<template lang="pug">
.project-file-category-list(:class="{ vertical }")
  .items
    .item(
      v-for="item in items"
      :key="item.id"
      @click="$emit('select', item)"
      :class="{ selected: item.id === (selected && selected.id) }"
    )
      .name {{ item.name  }}
      .file-count {{ filesCount[item['@id']] ? `Файлов ${filesCount[item['@id']]}` : 'Пусто' }}
</template>

<script>

export default {
  name: 'ProjectFileCategoryList',
  props: {
    items: Array,
    selected: Object,
    filesCount: Object,
    vertical: Boolean,
  },
};
</script>

<style scoped lang="scss">
.project-file-category-list {

  .items {
    display: flex;
    justify-content: space-between;
    column-gap: 23px;
    padding: 10px 0 22px;

    overflow-x: auto;
    &::-webkit-scrollbar { height: 7px; }
    &::-webkit-scrollbar-track {
      background: #EBF5FF;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: #C2E1FF;
      border-radius: 4px;
    }
  }

  &.vertical .items {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    column-gap: 20px;
    row-gap: 30px;
    overflow-x: auto;
  }

  .item {
    box-sizing: border-box;
    padding: 12px 13px;
    position: relative;
    background: #F8F9FC;
    border-radius: 0 6px 6px 6px;
    cursor: pointer;
    width: 95px;
    flex-shrink: 0;
    transition: box-shadow 0.05s ease-in-out, background-color 0.25s ease-in-out, top 0.1s ease-in-out;

    &:hover:not(:active) {
      top: -2px;
    }

    &:active {
      top: 0;
      box-shadow: none !important;
    }

    &:hover {
      box-shadow: 0 10px 10px -10px var(--color-dark-gray);
    }

    &:before {
      display: block;
      content: '';
      position: absolute;
      left: 0;
      bottom: 100%;
      border-bottom: 10px solid #F8F9FC;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      height: 0;
      width: 50px;
      transition: border-bottom 0.25s ease-in-out;
    }

    &.selected {
      background: #DBEDFF;
      border: none;

      &:before {
        border-bottom-color: #DBEDFF;
      }
    }
  }

  .name {
    font-size: 12px;
    line-height: 15px;
    font-weight: bold;
    letter-spacing: 0.01em;
    color: #000000;
    height: 45px;
    overflow: hidden;
  }

  .file-count {
    font-size: 11px;
    line-height: 14px;
    letter-spacing: 0.01em;
    color: var(--color-middle-gray);
  }

  @media (max-width: 992px) {
    .items {
      overflow-x: scroll;
    }

    &.vertical .items {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
  }

  @media (max-width: 650px) {
    &.vertical .items {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  @media (max-width: 450px) {
    &.vertical .items {
      grid-template-columns: 1fr 1fr;
    }
  }
}
</style>
